import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Popover } from '../../utils/materialUI';
import SubscriptionWidget from './subscriptionWidget';
import '../../assets/styles/SubscriptionWidgetPopup.css';

class SubscriptionPopup extends Component {
    handleClose = () => {
        this.props.handleClose();
    };

    render() {
        const { open, handleClose } = this.props;
        if (open) {
            return (
                <Popover
                    anchorReference="anchorOrigin"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={open}
                    onClose={handleClose}
                    disableRestoreFocus
                >
                    <div className="content-container">
                        <button type="submit" className="popup-close" onClick={this.handleClose}>
                            <span className="fa fa-close" />
                        </button>
                        <SubscriptionWidget />
                    </div>
                </Popover>
            );
        }
        return null;
    }
}

SubscriptionPopup.propTypes = {
    open: PropTypes.any.isRequired,
    handleClose: PropTypes.func.isRequired,
};

export default SubscriptionPopup;
